angular.module('account.settings')
    .component('accountSettingsLanguageComponent', {
        templateUrl: 'app/account/settings/language.html',
        controller: function (toastr, localeService) {
            this.$onInit = () => {
                this.languages = [{name: 'polish', code: 'pl_PL'}, {name: 'english', code: 'en_GB'}]
                this.item = {
                    language: localeService.getLanguage()
                }
            }

            this.save = () => {
                localeService.setLanguage(this.item.language)
                toastr.success("Zapisano")
                location.reload()
            }
        }
    })
